import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogData } from '@next/core-lib/dialog';

import { ProtectedFieldsSkippedGroup } from '../../models';

export interface ProtectedFieldsSkippedDialogData extends AbstractDialogData {
  groups: ProtectedFieldsSkippedGroup[];
}

@Component({
  selector: 'app-protected-fields-skipped-dialog',
  templateUrl: './protected-fields-skipped-dialog.component.html',
  styleUrls: ['./protected-fields-skipped-dialog.component.scss'],
  standalone: false,
})
export class ProtectedFieldsSkippedDialogComponent extends AbstractDialog<void> {
  data = inject<ProtectedFieldsSkippedDialogData>(MAT_DIALOG_DATA);
  protected mdDialogRef = inject<MatDialogRef<ProtectedFieldsSkippedDialogComponent>>(MatDialogRef);

  totalSkippedFields = this.data.groups.reduce((sum, group) => sum + group.skippedFields.length, 0);

  trackByCropFieldId(_index: number, group: ProtectedFieldsSkippedGroup): number {
    return group.cropFieldId;
  }

  trackBySkippedField(_index: number, field: string): string {
    return field;
  }

  getFieldTranslationKey(field: string): string {
    const key = field.charAt(0).toLowerCase() + field.slice(1);
    return `protectedFieldsSkippedDialog.fields.${key}`;
  }
}
